export { showFooter } from './showFooter';
